"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var saveMailboxJunkEmailConfiguration_1 = require("./actions/saveMailboxJunkEmailConfiguration");
exports.saveMailboxJunkEmailConfiguration = saveMailboxJunkEmailConfiguration_1.default;
var getMailboxJunkEmailConfiguration_1 = require("./utils/getMailboxJunkEmailConfiguration");
exports.getMailboxJunkEmailConfiguration = getMailboxJunkEmailConfiguration_1.default;
var initMailboxJunkEmailConfiguration_1 = require("./actions/initMailboxJunkEmailConfiguration");
exports.initMailboxJunkEmailConfiguration = initMailboxJunkEmailConfiguration_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-junkmail-configuration/lib/index.js
// module id = 2894
// module chunks = 2